import { render } from "./IconBtn.vue?vue&type=template&id=65f40c94&ts=true"
import script from "./IconBtn.vue?vue&type=script&lang=ts"
export * from "./IconBtn.vue?vue&type=script&lang=ts"

import "./IconBtn.vue?vue&type=style&index=0&id=65f40c94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__